import log from 'loglevel';
import { takeEvery, fork, all, call } from 'redux-saga/effects';

import { Action } from 'typesafe-actions';
import { analyticsUtils } from 'utils';
import { runAddToShoppingListDetector } from './messages/ga-addtoshoppinglist.pdp';
import { runAddToCartDetector } from './messages/ga-addtocart.pdp';
import { runClickMediaPreviewDetector } from './messages/ga-clickmediapreview.pdp';
import { runClickStocksListDetector } from './messages/ga-clickstockslist.pdp';
import { putGaDetailSet, runDetailDetector } from './messages/ga-detail.pdp';
import { putGaPageView, runPageViewDetector } from './messages/ga-pageview.pdp';
import { runRemoveFromCartDetector } from './messages/ga-removefromcart.pdp';
import { runRemoveFromShoppingListDetector } from './messages/ga-removefromshoppinglist.pdp';
import { putGaShoppilot, runShoppilotDetector } from './messages/ga-shoppilot.pdp';
import { awaitGtmReady } from './utils';
import { runReviewsGaDetectors } from './messages/reviews';
import { DispatchGaMessage } from './messages/types';
import { runRelatedServicesGaDetectors } from './messages/related-services/detectors';
import { runGaStickyPanelButtonClickDetector } from './messages/ga-stickypanel.pdp';
import { runVariantsGaDetectors } from './messages/variants/detectors';
import { runMediaLoadDetector } from './messages/ga-mediaload.pdp';
import { runCalculateQuantityDetector } from './messages/ga-calculate-quantity-open.pdp';
import { runCalculateQuantityCloseDetector } from './messages/ga-calculate-quantity-close.pdp';
import { runSelectTintServiceGaDetectors } from './messages/select-tint-service/detectors';
import { runSetsGaDetectors } from './messages/sets';
import { runCalculateQuantityShowDetector } from './messages/ga-calculate-quantity-show.pdp';

export function* dispatchGaEvent(message: DispatchGaMessage) {
  yield analyticsUtils.sendEvent(message?.type, message?.payload);
}

export function* runGaDispatcher() {
  yield fork(runGaDetectors);
  yield takeEvery((action: Action) => action.type.startsWith('GA:'), dispatchGaEvent);

  try {
    yield awaitGtmReady();
    yield putGaPageView();
    yield putGaShoppilot();
    yield putGaDetailSet();
  } catch (err) {
    log.error(err);
  }
}

export function* runGaDetectors() {
  yield all([
    call(runAddToCartDetector),
    call(runRemoveFromCartDetector),

    call(runAddToShoppingListDetector),
    call(runRemoveFromShoppingListDetector),

    call(runClickStocksListDetector),

    call(runShoppilotDetector),

    call(runClickMediaPreviewDetector),
    call(runMediaLoadDetector),

    call(runPageViewDetector),

    call(runReviewsGaDetectors),

    call(runRelatedServicesGaDetectors),

    call(runGaStickyPanelButtonClickDetector),

    call(runDetailDetector),

    call(runVariantsGaDetectors),

    call(runCalculateQuantityDetector),

    call(runCalculateQuantityCloseDetector),

    call(runSelectTintServiceGaDetectors),

    call(runSetsGaDetectors),
    call(runCalculateQuantityShowDetector),
  ]);
}
